import { render, staticRenderFns } from "./aufgaben_table_internal.vue?vue&type=template&id=2d3c9870&scoped=true"
import script from "./aufgaben_table_internal.vue?vue&type=script&lang=js"
export * from "./aufgaben_table_internal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c9870",
  null
  
)

export default component.exports